import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { BRAND } from "@/data/site";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "", company: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await register(form);
      navigate("/dashboard");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Registration failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-ink px-5 py-20" data-testid="register-page">
      <div className="w-full max-w-md">
        <Link to="/" className="mb-8 flex items-center justify-center gap-3">
          <div className="overflow-hidden rounded-md bg-[#EEF2FB] p-1"><img src={BRAND.logo} alt="logo" className="h-10 w-10 object-contain" /></div>
          <span className="font-heading text-lg font-bold text-white">Unicorn Valley</span>
        </Link>
        <div className="rounded-2xl bg-white p-8">
          <h1 className="font-heading text-2xl font-semibold text-ink">Create your account</h1>
          <p className="mt-1 text-sm text-slate-500">Track sourcing projects and shipments in one place.</p>
          <form onSubmit={submit} className="mt-6 space-y-4">
            <input required placeholder="Full name" value={form.name} onChange={set("name")} data-testid="register-name" className="w-full rounded-md border border-slate-200 px-4 py-3 text-sm outline-none focus:border-teal focus:ring-2 focus:ring-teal/30" />
            <input required type="email" placeholder="Email" value={form.email} onChange={set("email")} data-testid="register-email" className="w-full rounded-md border border-slate-200 px-4 py-3 text-sm outline-none focus:border-teal focus:ring-2 focus:ring-teal/30" />
            <input placeholder="Company (optional)" value={form.company} onChange={set("company")} data-testid="register-company" className="w-full rounded-md border border-slate-200 px-4 py-3 text-sm outline-none focus:border-teal focus:ring-2 focus:ring-teal/30" />
            <input required type="password" placeholder="Password" value={form.password} onChange={set("password")} data-testid="register-password" className="w-full rounded-md border border-slate-200 px-4 py-3 text-sm outline-none focus:border-teal focus:ring-2 focus:ring-teal/30" />
            {error && <p className="text-sm text-red-600" data-testid="register-error">{error}</p>}
            <button type="submit" disabled={loading} data-testid="register-submit" className="w-full rounded-md bg-gradient-to-r from-[#1E73BE] to-[#16B894] px-6 py-3.5 text-sm font-semibold text-white hover:-translate-y-0.5 transition-transform disabled:opacity-60">
              {loading ? "Creating…" : "Create Account"}
            </button>
          </form>
          <p className="mt-5 text-center text-sm text-slate-500">
            Already have an account? <Link to="/login" className="font-semibold text-teal hover:underline">Sign in</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
